import { createAction } from '@reduxjs/toolkit';
import { FullscreenPreviewShape } from './model';

export const assetIdChanged = createAction<{ id: FullscreenPreviewShape['singleAssetId'] }>(
  'al/fullscreenPreview/assetIdChanged',
);

export const assetChanged = createAction<{
  asset: FullscreenPreviewShape['singleAsset'];
  error: FullscreenPreviewShape['singleAssetError'];
}>('al/fullscreenPreview/assetChanged');
